module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0135.jpg?v=f1469a7c";